export default "__VITE_ASSET__DvAFY8Az__"